export default __webpack_public_path__ + "static/media/SeqLSTM-Bar.eb6f9f5b.png";